import { Backdrop, CircularProgress } from '@mui/material'

interface Props {
  isLoading: boolean
  withBackdrop?: boolean
}

const PageSpinner = ({ isLoading, withBackdrop }: Props) => {
  return (
    <Backdrop open={isLoading} invisible={!withBackdrop} sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
      <CircularProgress />
    </Backdrop>
  )
}

PageSpinner.default = {
  withBackdrop: false,
}

export default PageSpinner
